import React, {useState, useEffect} from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'

import theme from 'styles'

import AppContext from './AppContext'
import LandingPage from 'components/pages/LandingPage'
import TopicSelectorPage from 'components/pages/TopicSelectorPage'
import TopicContentPage from 'components/pages/TopicContentPage'
import { getFootprint, getLocales, getMarkets, getTopics, getTranslations } from 'api/api'
import Locale from 'models/Locale'
import Region from 'models/Region'
import Translation from 'models/Translation'
import Topic from 'models/Topic'
import Market from 'models/Market'
import Footprint from 'models/Footprint'

const pages = [
    { name: 'landing', theme},
    { name: 'topics', theme },
    { name: 'content', theme },
]

const App: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(0)
    const [locale, setLocale] = useState("en_GB")
    const [locales, setLocales] = useState<Locale[]>([{ name: "United Kingdom (English)", code: "en_GB" }])
    const [text, setText] = useState<Translation>({})
    const [footprint, setFootprint] = useState<Footprint | undefined>(undefined)
    const [markets, setMarkets] = useState<Market[]>([])
    const [regionFilter, setRegionFilter] = useState<Region[]>([])
    const [regionFilterIds, setRegionFilterIds] = useState<number[]>([])
    const [topics, setTopics] = useState<Topic[]>([])
    const [selectedTopic, setSelectedTopic] = useState<Topic | undefined>(undefined)

    useEffect(() => {
        const loadAsync = async () => {
            try {
                const locales = await getLocales()
                console.log("Loaded Locales", locales)
                setLocales(locales)
                if (locales.length > 0) {
                    var id = 0
                    console.log(window.location.search)
                    const query = new URLSearchParams(window.location.search)
                    const localeParam = query.get('locale')

                    if( localeParam ) {
                        console.log('Setting Locale To ' + localeParam)
                        const index = locales.findIndex(object => {
                            return object.code === localeParam
                        })
                        if( index > 0 ) {
                            id = index
                        }
                    }
                    setLocale(locales[id].code)
                }
            } catch (err) {
                console.log("Error loading locations", err.toString())
            }
        }

        loadAsync()
    }, [])

    useEffect(() => {
        const loadAsync = async () => {
            try {
                const text = await getTranslations(locale)
                setText(text)
            } catch (err) {
                console.log("Error loading translations", err.toString())
            }
        }

        loadAsync()
    }, [locale])

    useEffect(() => {
        const loadAsync = async () => {
            try {
                const topics = await getTopics(locale)
                console.log("Loaded Topics", topics)
                setTopics(topics)
            } catch (err) {
                console.log("Error loading topics", err.toString())
            }
        }

        loadAsync()
    }, [locale])

    useEffect(() => {
        const loadAsync = async () => {
            try {
                const footprint = await getFootprint(locale)
                setFootprint(footprint)
            } catch (err) {
                console.log("Error loading footprint", err.toString())
            }
        }

        loadAsync()
    }, [locale])

    useEffect(() => {
        const loadAsync = async () => {
            try {
                const markets = await getMarkets(locale)
                setMarkets(markets)
            } catch (err) {
                console.log("Error loading markets", err.toString())
            }
        }

        loadAsync()
    }, [locale])
    
    useEffect(() => {
        if (topics.length > 0) {
            const topic = topics[0]
            setSelectedTopic(topic)
        }
    }, [topics])

    useEffect(() => {
        setRegionFilterIds(regionFilter.flatMap(region => region.id))
    }, [regionFilter])

    const handleSelectLocale = (locale: string) => {
        console.log("Setting locale", locale)
        setLocale(locale)
    }

    const handleSelectRegions = (regions: Region[]) => {
        console.log("Setting region filter", regions)
        setRegionFilter(regions)
    }

    const handleSelectTopic = (topicId: number) => {
        const topic = topics.find(topic => topic.id === topicId)
        if (topic != null) {
            setSelectedTopic(topic)
        }
        setCurrentPage(2)
    }

    const handleSelectCountry = () => {
        setCurrentPage(0)
    }

    const handleNavigate = (page: number) => {
        setCurrentPage(page)
    }

    const renderCurrentPage = () => {
        console.log("Rendering page:", pages[currentPage].name)

        switch (pages[currentPage].name) {
            case 'landing':
                return (<LandingPage onSelectLocale={handleSelectLocale} onSelectRegions={handleSelectRegions}/>)

            case 'topics':
                return (<TopicSelectorPage onSelectTopic={handleSelectTopic} onSelectCountry={handleSelectCountry} />)

            case 'content':
                if (selectedTopic != null) {
                    return (<TopicContentPage topic={selectedTopic} onSelectTopic={handleSelectTopic} />)
                }
                // falls through

            default:
                return null
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppContext.Provider value={{locales, locale, text, topics, footprint, markets: markets, regionFilterIds, regionFilter, onNavigate: handleNavigate}}>
                {renderCurrentPage()}
            </AppContext.Provider>
        </ThemeProvider>
    )
}

export default App
